module.exports = __webpack_public_path__ + "ffb58e9c2da89dea619a1f3ca5c7cda0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/App/screens/Home/images/beAnAliada.jpg
// module id = 1462
// module chunks = 0